import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { UsersAppDataProviderFactory } from '../factory/UsersAppDataProviderFactory';
import { UsersAppBaseDataProvider } from '../dataProvider/UsersAppBaseDataProvider';
import { UsersAppWebComponentSchema } from '../types';

export class UsersAppRepository extends BaseWebComponentRepository {
  public dataProviderFactory: UsersAppDataProviderFactory;
  public dataProvider: UsersAppBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new UsersAppDataProviderFactory(),
    });
  }

  async getDataForView(): Promise<UsersAppWebComponentSchema> {
    return this.dataProvider.getDataForView();
  }
}
